// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"9c8a9b26","453":"5a36dc01","952":"244c1e0d"}[chunkId] + ".chunk.js";
};